// eslint-disable-next-line import/no-extraneous-dependencies
import { enUS, th } from "date-fns/locale";

import GoApi from "@/libs/client/goApi/goApi";
import type { RequestHotelDisplayNameByLatLongInterface } from "@/libs/client/goApi/hotel/hotelServiceInterfaces/getHotelDisplayNameByLatLongInterface";

export async function getHotelByLatLong() {
  const position = await new Promise<GeolocationPosition>((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });

  const paramsHotelDisplayName = {
    latitude: position.coords.latitude,
    longitude: position.coords.longitude,
    type: "hotelLatLng",
  } as RequestHotelDisplayNameByLatLongInterface;

  const responseHotelByLatLong = await GoApi.hotel.getDisplayNameByLatLong(
    paramsHotelDisplayName,
  );
  return responseHotelByLatLong;
}

export async function getHotelNearMeByLatLong() {
  const position = await new Promise<GeolocationPosition>((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });

  const paramsHotelDisplayName = {
    latitude: position.coords.latitude,
    longitude: position.coords.longitude,
    type: "hotelLatLng",
  } as RequestHotelDisplayNameByLatLongInterface;

  const responseHotelByLatLong = await GoApi.hotel.getDisplayNameByLatLong(
    paramsHotelDisplayName,
  );

  const displayNameHotel = responseHotelByLatLong.displayName;
  return displayNameHotel;
}

export async function getLocation(): Promise<any | undefined> {
  const key = process.env.NEXT_PUBLIC_API_MAP_KEY || "";

  if ("geolocation" in navigator) {
    try {
      const position = await new Promise<GeolocationPosition>(
        (resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        },
      );
      const { latitude, longitude } = position.coords;

      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${key}`,
      );

      return await response.json();
    } catch (error) {
      return undefined;
    }
  } else {
    return undefined;
  }
}

export async function getDistrictByLocation(): Promise<string> {
  const data = await getLocation();

  if (!data) return "";

  const addressComponents = data.results.find(
    (address: { address_components: any[] }) =>
      address.address_components.find((asdd: { types: string | string[] }) =>
        asdd.types.includes("administrative_area_level_2"),
      ),
  );

  const districtComponent = addressComponents?.address_components.find(
    (component: { types: string | string[] }) =>
      component.types.includes("administrative_area_level_2"),
  );

  const district = districtComponent ? districtComponent.long_name : "";

  return district;
}

export function calWeightingScore(
  isTop100: number,
  review: number,
  starRating: number,
): number {
  let reviewScore = 0;
  if (review >= 4) {
    reviewScore = 5;
  } else if (review === 3) {
    reviewScore = 3;
  } else if (review <= 2) {
    reviewScore = 2;
  }
  let starScore = 0;
  if (starRating >= 4) {
    starScore = 5;
  } else if (starRating === 3) {
    starScore = 3;
  } else if (starRating <= 2) {
    starScore = 2;
  }
  let campaignScore = 0;
  if (isTop100 > 0) {
    campaignScore = 5;
  }
  return campaignScore * 0.2 + reviewScore * 0.2 + starRating * 0.2;
}

export function getCurrentLocaleWithDateFns(locale?: string | null): Locale {
  if (!locale) return enUS;

  const asd = locale.slice(0, 2);

  if (asd === "th") {
    return th;
  }

  return enUS;
}

export function filterEmptyValues(
  obj: Record<string, any>,
  fieldsToRemove: string[] = [],
): Record<string, any> {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([key, value]) =>
        value !== null &&
        value !== undefined &&
        value !== 0 &&
        value !== "0" &&
        value !== "" &&
        !fieldsToRemove.includes(key),
    ),
  );
}

export function kebabToSpaceSeparated(input: string): string {
  return input.replace(/-/g, " ");
}

export function appendFormData(formData: FormData, data: any, parentKey = "") {
  if (data && typeof data === "object" && !(data instanceof File)) {
    Object.keys(data).forEach((key) => {
      const value = data[key];
      const fullKey = parentKey ? `${parentKey}[${key}]` : key;

      if (Array.isArray(value)) {
        value.forEach((v, i) => {
          appendFormData(formData, v, `${fullKey}[]`);
        });
      } else if (value instanceof File) {
        formData.append(fullKey, value);
      } else if (typeof value === "object" && value !== null) {
        appendFormData(formData, value, fullKey);
      } else {
        formData.append(fullKey, value);
      }
    });
  } else {
    formData.append(parentKey, data);
  }
}
